import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app-auth/services/authentication.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  constructor(private auth: AuthenticationService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    const redirectUrl = this.route.snapshot.queryParamMap.get('redirect_url');
    this.auth.logout(redirectUrl);
  }
}
